import axios from 'axios';
import constants from '../constants';

const CONFIG_PATH = constants.urlPrefix + '/api/config';

function initApp(id, parentId, locationId, size) {
  return axios.get(CONFIG_PATH + '/init', {
    params: {
      id,
      parentId,
      locationId,
      size
    }
  });
}

export default {
  initApp
}
